<template>
<div class="footerDownload">
    <div class="download">
        <div class="down-left">
            <div class="logo">
                <img src="../../assets/logo.png" alt="">
            </div>
            <div class="text">
                <div>沃米易学-易学易记易通过！</div>
                <p>海量题目，请下载APP体验！</p>
            </div>
        </div>
        <div class="down-right">
            <a href="http://app.hxwomi.com/download">立即下载</a>
        </div>
    </div>
    <div class="downloads"></div>
</div>
</template>

<script>
export default {
  name: "footerDownload",
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
.download {
  font-size: 0;
  height: 100px;
  position: fixed;
  bottom: -1PX;
  left: 0;
  background: #fff;
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0px -3px 10px #f0f0f0;
  .down-right {
    float: right;
    padding-top: 1PX;
    a {
      margin-top: 25px;
      display: block;
      background: #ff7f02;
      color: #fff;
      box-sizing: border-box;
      font-size: 26px;
      /*line-height: 46px;*/
      padding: 10px 16px;
    }
  }
  .down-left {
    float: left;
    overflow: hidden;
    margin-top: 17px;
    .logo {
      float: left;
      width: 64px;
      height: auto;
      img {
        width: 100%;
        height: auto;
        display: block;
      }
      margin-right: 20px;
    }
    .text {
      font-size: 10px;
      float: left;
      div {
        font-size: 28px;
        color: #ff7f02;
        line-height: 1;
        margin: 4PX 0 6px;
      }
      p {
        font-size: 22px;
        line-height: 1;
        color: #333;
      }
    }
  }
}
.downloads {
  height: 100px;
}
</style>
